const languages: LanguageKey[] = ['fr', 'en'];

export default languages;
